import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormState } from 'react-hook-form';
import { FormField } from '@wit-support/ui';
/**
 * Звёздочка обязательного поля (`meta.required`) — псевдоэлементом, а не
 * текстом: подпись остаётся ровно подписью (поиск поля по ней, `aria-label`
 * связанного ввода не получают лишнего «*»).
 */
const REQUIRED_MARK = "after:ml-1 after:text-[var(--color-state-danger-fg)] after:content-['*']";
/**
 * Common wrapper for widgets. Renders label + control + description + error.
 *
 * Error display is gated: errors only show once the field has been touched
 * (blurred) or the form has been submitted. This prevents RHF from flashing
 * "Required" messages on empty fields as soon as a dialog opens.
 */
export function FieldShell({ meta, fieldState, label, description, hint, htmlFor, children, }) {
    const resolvedLabel = label ?? meta.label;
    const resolvedDescription = description ?? meta.description;
    const resolvedHint = hint ?? meta.hint;
    const formState = useFormState();
    const showError = fieldState.isTouched || formState.isSubmitted;
    // Ошибку читаем БЕЗУСЛОВНО, а прячем уже готовое значение: react-hook-form
    // включает подписку поля на `errors` по факту обращения к свойству, и чтение
    // под условием оставляло поле без подписки — до первого обращения перерендера
    // не происходило, и сообщение не появлялось вовсе (нажатие «Сохранить» на
    // пустом обязательном поле выглядело как «ничего не произошло»).
    const message = fieldState.error?.message;
    const error = showError ? message : undefined;
    return (_jsxs(FormField, { children: [resolvedLabel ? (_jsx(FormField.Label, { htmlFor: htmlFor, ...(meta.required === true ? { className: REQUIRED_MARK, 'data-required': '' } : {}), children: resolvedLabel })) : null, _jsx(FormField.Control, { children: children }), resolvedDescription ? (_jsx(FormField.Description, { children: resolvedDescription })) : null, resolvedHint && !resolvedDescription ? (_jsx(FormField.Description, { children: resolvedHint })) : null, error ? _jsx(FormField.Error, { children: error }) : null] }));
}
//# sourceMappingURL=field-shell.js.map